import { MantineThemeOverride } from "@mantine/core";
import dayjs from "dayjs";

export const theme: MantineThemeOverride = {
  fontFamily: "Poppins, sans serif",
  headings: { fontFamily: "Nunito, sans-serif" },
  components: {
    Button: {
      defaultProps: {
        radius: "md",
      },
    },
    Tooltip: {
      defaultProps: {
        withArrow: true,
        radius: "md",
      },
    },
    DatePickerInput: {
      defaultProps: {
        minDate: dayjs().subtract(3, "years").toDate(),
        placeholder: "DDMMYY / DDMMYYYY",
      },
    },
    DateInput: {
      defaultProps: {
        minDate: dayjs().subtract(3, "years").toDate(),
        placeholder: "DDMMYY / DDMMYYYY",
        dateParser: (dateString: string) => {
          if (!dateString) return null;

          let targetDate: Date;
          const isNumeric = /^\d+$/.test(dateString);
          const numericValue = dateString.replace(/\D/g, "");

          if (isNumeric) {
            if (numericValue.length === 8) {
              const parsed = dayjs(numericValue, "DDMMYYYY", true);
              targetDate = parsed.isValid() ? parsed.toDate() : new Date(NaN);
            } else if (numericValue.length === 6) {
              const parsed = dayjs(numericValue, "DDMMYY", true);
              targetDate = parsed.isValid() ? parsed.toDate() : new Date(NaN);
            } else if (numericValue.length > 0) {
              // Any other length numeric string is considered invalid immediately
              // to trigger the red error border and message
              return new Date(NaN);
            } else {
              return null;
            }
          } else {
            // Non-numeric or mixed (like DD/MM/YYYY)
            const parsed = dayjs(dateString, "DD/MM/YYYY", true);
            targetDate = parsed.isValid()
              ? parsed.toDate()
              : dayjs(dateString).toDate();
          }

          return targetDate;
        },
      },
    },
  },
};
